/** @format */

// const baseURL = "http://192.168.18.8:5000/api/";
const baseURL = "https://dummy-alphadnd-server.herokuapp.com/api/";
// export const baseURL = "http://localhost:5000/api/";
export const LOAD_JSON_URL = baseURL + "apps/json/";
export const APPS_URL = baseURL + "apps/";
export const SIGNUP_URL = baseURL + "users";
export const LOGIN_URL = baseURL + "auth";